import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Guide, Review } from '../data/site';
export function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <Link to={`/reviews/${review.slug}`} className="group flex flex-col bg-white border border-stone-200 rounded-sm overflow-hidden transition-shadow hover:shadow-lg" data-id="element-37">
      <div className="relative aspect-[16/10] overflow-hidden" data-id="element-38">
        <img src={review.image} alt={review.product} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-39" />
        <span className="absolute top-3 left-3 bg-ink/90 text-paper text-xs font-600 px-2.5 py-1 rounded-sm tabular-nums" data-id="element-40">
          {review.trustScore}/100
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1" data-id="element-41">
        <p className="eyebrow text-trust-600 mb-3" data-id="element-42">{review.category}</p>
        <h3 className="font-serif text-xl tracking-tightest text-ink leading-snug" style={{
        fontWeight: 500
      }} data-id="element-43">
          {review.title}
        </h3>
        <p className="mt-3 text-sm text-stone-600 leading-relaxed flex-1" data-id="element-44">
          {review.excerpt}
        </p>
        <span className="mt-5 inline-flex items-center gap-1 text-sm font-600 text-ink group-hover:text-trust-700 transition-colors" data-id="element-45">
          Read review
          <ArrowUpRightIcon className="h-4 w-4" data-id="element-46" />
        </span>
      </div>
    </Link>;
}
export function GuideCard({
  guide
}: {
  guide: Guide;
}) {
  return <Link to={`/buying-guides/${guide.slug}`} className="group flex flex-col bg-white border border-stone-200 rounded-sm overflow-hidden transition-shadow hover:shadow-lg" data-id="element-47">
      <div className="aspect-[16/10] overflow-hidden" data-id="element-48">
        <img src={guide.image} alt={guide.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-49" />
      </div>
      <div className="p-6 flex flex-col flex-1" data-id="element-50">
        <div className="flex items-center gap-3 mb-3" data-id="element-51">
          <p className="eyebrow text-trust-600" data-id="element-52">{guide.category}</p>
          <span className="text-stone-300" data-id="element-53">·</span>
          <p className="text-xs text-stone-500" data-id="element-54">{guide.readTime}</p>
        </div>
        <h3 className="font-serif text-xl tracking-tightest text-ink leading-snug" style={{
        fontWeight: 500
      }} data-id="element-55">
          {guide.title}
        </h3>
        <p className="mt-3 text-sm text-stone-600 leading-relaxed flex-1" data-id="element-56">
          {guide.excerpt}
        </p>
        <span className="mt-5 inline-flex items-center gap-1 text-sm font-600 text-ink group-hover:text-trust-700 transition-colors" data-id="element-57">
          Read guide
          <ArrowUpRightIcon className="h-4 w-4" data-id="element-58" />
        </span>
      </div>
    </Link>;
}